import { __decorate, __param } from 'tslib';
import { InjectionToken, NgModule, Inject, PLATFORM_ID, ApplicationInitStatus, Injectable } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
var GtmModule_1;
/**
 * Defines Injection token of `GtmConfig` for configuring module
 */
const gtmConfigService = new InjectionToken('GtmConfig');
/**
 * @usageNotes
 *
 * Import in your App Module as follows:
 *
 * ```
 *
 * @NgModule({
 *   imports: [
 *     // ...
 *     GtmModule.forRoot({
 *       gtmId: 'GTM-XXXXXXX',
 *     }),
 *   ],
 * })
 * class AppModule {}
 * ```
 *
 */
let GtmModule = GtmModule_1 = class GtmModule {
    /**
     * Creates and configures GTM module.
     *
     * @param config An `GtmModule` object that specifies library configuration
     */
    static forRoot(config) {
        return {
            ngModule: GtmModule_1,
            providers: [
                GtmService,
                {
                    provide: gtmConfigService,
                    useValue: config,
                }
            ],
        };
    }
};
GtmModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: GtmModule });
GtmModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function GtmModule_Factory(t) { return new (t || GtmModule)(); } });

let GtmService = class GtmService {
    constructor(config, platformId, domDocument, applicationInitStatus) {
        this.config = config;
        this.platformId = platformId;
        this.applicationInitStatus = applicationInitStatus;
        /**
         * Indicates whenever GTM was initialized
         */
        this.initialized = false;
        /**
         * Stores pushes to dataLayer that will be added to dataLayer once the app will be initialized
         */
        this.postponedPushes = [];
        this.domDocument = domDocument;
        this.postponeInitialization();
    }
    /**
     * Push any object do GTM dataLayer
     *
     * @param obj - object that will be pushed to dataLayer
     */
    push(obj) {
        if (this.initialized) {
            this.pushToDataLayer(obj);
        }
        else {
            this.postponedPushes.push(obj);
        }
    }
    /**
     * Waits for app initialization and then initialize module
     */
    postponeInitialization() {
        this.applicationInitStatus.donePromise
            .then(() => {
            this.init();
        });
    }
    /**
     * Initialize service - create dataLayer and setup necessary HTML code
     */
    init() {
        if (!this.config || (this.config && !(!!this.config.gtmId || this.config.isEnabled === false))) {
            throw new Error('gtmId must be provided');
        }
        if (!this.initialized && this.config.isEnabled !== false) {
            this.initDataLayer();
            this.pushToDataLayer({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
            this.appendGtmTags();
            this.pushPostponed();
        }
        this.initialized = true;
    }
    /**
     * Initialize global dataLayer variable
     */
    initDataLayer() {
        if (isPlatformBrowser(this.platformId)) {
            window.dataLayer = [];
        }
    }
    /**
     * Provide dataLayer (or noop one for server platform)
     */
    getDataLayer() {
        return isPlatformBrowser(this.platformId) ? window.dataLayer : [];
    }
    /**
     * Push all postponed pushes to dataLayer
     */
    pushPostponed() {
        this.postponedPushes.forEach(obj => this.pushToDataLayer(obj));
        this.postponedPushes = [];
    }
    /**
     * Push object do dataLayer
     * @param obj - object to be pushed
     */
    pushToDataLayer(obj) {
        if (this.config.isEnabled !== false) {
            const dataLayer = this.getDataLayer();
            dataLayer.push(obj);
        }
    }
    /**
     * Append necessary elements to DOM
     */
    appendGtmTags() {
        if (isPlatformBrowser(this.platformId)) {
            this.domDocument.head.prepend(this.buildGtmScript());
            this.domDocument.body.prepend(this.buildGthIframe());
        }
    }
    /**
     * Create GTM initialization script
     */
    buildGtmScript() {
        const gtmScript = this.domDocument.createElement('script');
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${this.config.gtmId}`;
        gtmScript.async = true;
        return gtmScript;
    }
    /**
     * Create GTM noscript iframe
     */
    buildGthIframe() {
        const gtmIframe = this.domDocument.createElement('iframe');
        gtmIframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${this.config.gtmId}`);
        gtmIframe.style.width = '0';
        gtmIframe.style.height = '0';
        gtmIframe.style.display = 'none';
        gtmIframe.style.visibility = 'hidden';
        const gtmNoscript = this.domDocument.createElement('noscript');
        gtmNoscript.innerHTML = gtmIframe.outerHTML;
        return gtmNoscript;
    }
};
GtmService.ɵfac = function GtmService_Factory(t) { return new (t || GtmService)(ɵngcc0.ɵɵinject(gtmConfigService), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationInitStatus)); };
GtmService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: GtmService, factory: GtmService.ɵfac });
GtmService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [gtmConfigService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ApplicationInitStatus }
];
GtmService = __decorate([ __param(0, Inject(gtmConfigService)),
    __param(1, Inject(PLATFORM_ID)),
    __param(2, Inject(DOCUMENT))
], GtmService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GtmModule, [{
        type: NgModule
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GtmService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [gtmConfigService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ApplicationInitStatus }]; }, null); })();

/*
 * Public API Surface of ngx-gtm
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GtmModule, GtmService, gtmConfigService };

//# sourceMappingURL=ngx-gtm.js.map